module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAGFBMVEUAAAD///////////////////////////8jfp1fAAAAB3RSTlMAQIC/z6BwyjoSwgAAAHJJREFUCNc1jjsOgzAQBWdxJLegFG4XpXBrKQVtEuUAdPScwDaCvT4fiafXTDMaAGm59jT7Abil85MCscWtCzQVuhIOUrDkEl6RfD7w7gtSCE21BAU/ZxFbMw9TXB8/yAZe4wiDEqVyGvU/JICX2Re4M3bO+xGVwxKPcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/Bottom/img3.png
// module id = NcNc
// module chunks = 41